import React, { useEffect, useState } from "react";
import { AppLangue } from "src/commun/AppTypes";
import { useAppState } from "src/app/state/StateProvider";
import { AppNestedMenu, MenuItemData } from "fer-react-components";
import AppIcon from "src/commun/composants/AppIcon";
import { useAppText } from "src/commun/composants/AppText";

const langues = {
  fr: {
    label: "FR",
  },
  de: {
    label: "DE",
  },
  en: {
    label: "EN",
  },
};

export const ChangeLangue = () => {
  const [state, dispatch] = useAppState();

  const { tString } = useAppText();

  useEffect(() => {
    setMenuItems(buildMenuItems(state.langue));
  }, [state.traductions]);

  const buildMenuItems = (currentLangue: AppLangue) => {
    const menuItem = {} as MenuItemData;
    menuItem.leftIcon = <AppIcon title={tString("menu.langues." + currentLangue)} className={"cursor-pointer couleurIconBleu"} name={currentLangue} size="26px"/>;

    menuItem.items = Object.keys(langues).filter(langue => langue !== currentLangue).map(langue => ({
      label: tString("menu.langues." + langue),
      callback: () => onChangeLanguage(langue as AppLangue),
      leftIcon: <AppIcon name={langue} size="26px" />
    }));

    return menuItem;
  };


  const [menuItems, setMenuItems] = useState<any>();

  const onChangeLanguage = (langue: AppLangue) => {
    dispatch({ type: "setLangue", payload: langue });
  };

  return <AppNestedMenu menuItemsData={menuItems}/>;
};
